var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.6123C0 5.98489 5.37258 0.612305 12 0.612305C18.6274 0.612305 24 5.98489 24 12.6123C24 19.2397 18.6274 24.6123 12 24.6123C5.37258 24.6123 0 19.2397 0 12.6123Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0009 8.48694C17.5517 8.63808 17.9854 9.08339 18.1326 9.64889C18.4001 10.6738 18.4001 12.8123 18.4001 12.8123C18.4001 12.8123 18.4001 14.9507 18.1326 15.9757C17.9854 16.5412 17.5517 16.9865 17.0009 17.1377C16.0028 17.4123 12.0001 17.4123 12.0001 17.4123C12.0001 17.4123 7.99741 17.4123 6.99923 17.1377C6.44846 16.9865 6.01472 16.5412 5.86752 15.9757C5.6001 14.9507 5.6001 12.8123 5.6001 12.8123C5.6001 12.8123 5.6001 10.6738 5.86752 9.64889C6.01472 9.08339 6.44846 8.63808 6.99923 8.48694C7.99741 8.21228 12.0001 8.21228 12.0001 8.21228C12.0001 8.21228 16.0028 8.21228 17.0009 8.48694ZM10.8001 11.0122V15.0122L14.0001 13.0123L10.8001 11.0122Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.9d47c6e6f528a2656eaa848ae137c8ea.svg";
export { ForwardRef as ReactComponent };